import apiClient from "./api";
import { getApiAccessToken } from "./UserService";
import {
  ObjectDeviationListItemType,
  ObjectDeviationMetadataType,
  ObjectDeviationType,
  UpsertObjectDeviationRequest,
} from "../types/ObjectDeviation";

const baseUrl = "/api/Deviations";

const authConfig = async () => {
  const token = await getApiAccessToken();
  return { headers: { Authorization: `Bearer ${token}` } };
};

export const getDeviationMetadata = async (
  addressSystemId: number,
  currentUserId: number,
): Promise<ObjectDeviationMetadataType> => {
  const config = await authConfig();
  const response = await apiClient.get(`${baseUrl}/metadata`, {
    ...config,
    params: { addressSystemId, currentUserId },
  });
  return response.data as ObjectDeviationMetadataType;
};

export const getDeviations = async (
  objectId: number,
  contractId: number,
  addressSystemId: number,
  currentUserId: number,
): Promise<ObjectDeviationListItemType[]> => {
  const config = await authConfig();
  const response = await apiClient.get(baseUrl, {
    ...config,
    params: { objectId, contractId, addressSystemId, currentUserId },
  });
  return response.data as ObjectDeviationListItemType[];
};

export const getDeviation = async (
  id: number,
  objectId: number,
  contractId: number,
  addressSystemId: number,
  currentUserId: number,
): Promise<ObjectDeviationType> => {
  const config = await authConfig();
  const response = await apiClient.get(`${baseUrl}/${id}`, {
    ...config,
    params: { objectId, contractId, addressSystemId, currentUserId },
  });
  return response.data as ObjectDeviationType;
};

export const createDeviation = async (
  request: UpsertObjectDeviationRequest,
  currentUserId: number,
): Promise<ObjectDeviationType> => {
  const config = await authConfig();
  const response = await apiClient.post(baseUrl, request, {
    ...config,
    params: { currentUserId },
  });
  return response.data as ObjectDeviationType;
};

export const updateDeviation = async (
  id: number,
  request: UpsertObjectDeviationRequest,
  currentUserId: number,
): Promise<ObjectDeviationType> => {
  const config = await authConfig();
  const response = await apiClient.put(`${baseUrl}/${id}`, request, {
    ...config,
    params: { currentUserId },
  });
  return response.data as ObjectDeviationType;
};

export const deleteDeviation = async (
  id: number,
  objectId: number,
  contractId: number,
  addressSystemId: number,
  currentUserId: number,
): Promise<void> => {
  const config = await authConfig();
  await apiClient.delete(`${baseUrl}/${id}`, {
    ...config,
    params: { objectId, contractId, addressSystemId, currentUserId },
  });
};
